export const LOADING_TEXT = 'Loading...'
export const REDIRECT_TO_DASHBOARD = '< Dashboard'
export const NO_DATA_FOUND_TX = 'No training data found.'
export const TITLE = 'Training Progress Report'
export const TRAINING_DESCRIPTION =
  'Training is designed for lesson instructors and staff with 0-1 year of experience using the Second Step® program.'
export const TRAINING_DESCRIPTION_DWB = `The "Teaching Digital Well-Being" course trains teachers how to facilitate this specialized unit. Each program has a separate course.`

export const PROGRAM_OPTION_K8_LABEL = 'K–8 Core Program Training'
export const PROGRAM_OPTION_DWB_LABEL = 'K–12 Digital Well-Being Unit'
